import { CheckoutType, MaterialType } from 'graphql-ts-types';

import type { ArticleMaterialType } from '../types/Article';

export const getMaskedCode = (maskedCode: string) => `****${maskedCode.slice(-4)}`;

export const isDigitalCheckout = (checkoutType: CheckoutType) =>
  checkoutType === CheckoutType.Digital;

export const getDigitalCheckoutPrefix = (checkoutType?: CheckoutType) =>
  isDigitalCheckout(checkoutType) ? '/giftcard' : '';

export const isGiftCard = (materialType: ArticleMaterialType) =>
  Boolean(materialType) && materialType === MaterialType.GiftCard;
